import React, { useEffect, useRef, useState } from 'react'
import './home-page.styles.scss';

import Layout from '@/components/layout-auth/layout.comp'
import HomeLanding from '@/components/HOME/home-landing/home-landing.component'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import EnrolledContainer from '@/components/HOME/enrolled/enrolled-container.conponent'
import ManagingContainer from '@/components/HOME/managing/managing-container.component'
import CreateEditGameContainer from '@/components/HOME/create-edit-game/create-edit-game-container.component'
import { getGameInvitesFromDb, getOrgInvitesFromDb } from '@/utils/getDataFromDb';
import { useSelector } from 'react-redux';
import { auth, UseCloudFunction } from '@/utils/firebase.utils';
import BugModal from '@/components/layout-auth/feedback-modal/bug-modal.component';
import JoinGameWithEmail from '@/components/HOME/join-game-with-email/join-game-with-email.component';

import MyOrgs from '@/components/HOME/orgs/my-orgs.page';
import ContentManagerContainer from '@/components/SHARED/content-manager/content-manager-container.component';
import ArchivedGamesContainer from '@/components/HOME/archived-games/archived-games-container.component';
import LegalApprovalModal from '@/components/SHARED/legal-approval-modal/legal-approval-modal.component';
import ViewArchivedGame from '@/components/HOME/archived-games/view-archived-game.component';
import OrgInviteHandlerModal from '@/components/HOME/invite-handler/org-invite-handler-modal.component';
import GameInviteHandlerModal from '@/components/HOME/invite-handler/game-invite-handler-modal.component';
import FeedbackModal from '@/components/layout-auth/feedback-modal/feedback-modal.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import D20 from '@/components/SHARED/d20-roll-dice/d20.component';
import AnnouncementModal from '@/components/SHARED/announcements/announcement-modal.component';
import ResourcesPage from '../../components/HOME/resources/resources.page';

const HomePage = ({
  orgs,
  managingList,
  enrolledList,
  archivedList
}) => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const profile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [orgInvites, setOrgInvites] = useState(null);
  const [gameInvites, setGameInvites] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [selectedOrgInvite, setSelectedOrgInvite] = useState(null);
  const [selectedGameInvite, setSelectedGameInvite] = useState(null);
  const [alertMessage, setAlertMessage ] = useState(null);
  const [ confirmMessage, setConfirmMessage ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const approveRef = useRef();
  const orgInvitesRef = useRef();
  const gameInvitesRef = useRef();
  const navigate = useNavigate();
  let regsListener;
  let orgInvitesListener;
  let gameInvitesListener;

  useEffect(() => {
    // change var(--primary) to default color

    var r = document.querySelector(':root');
    r.style.setProperty('--primary', '#674fa7');
    r.style.setProperty('--primary-trans', '#674fa7a6');

    const timeout = setTimeout(() => {
      const currentlySignedInUser = auth.currentUser;
      // console.log(currentlySignedInUser);
      if (!currentlySignedInUser || currentlySignedInUser.providerData.length === 0) {
        navigate('/logout');
      }
    }, 2000);

    return () => {
      // cancels any listeners
      if (regsListener) regsListener();
      if (orgInvitesListener) orgInvitesListener();
      if (gameInvitesListener) gameInvitesListener();
      if (timeout) clearTimeout(timeout);
    }
  }, [])

  useEffect(() => {
    if (!currentUser) return;
    if (currentUser.provider === 'FirestoreAuth') {
      navigate('/logout');
    }
  }, [currentUser])

  useEffect(() => {
    if (!profile) return;
    if (!profile.fName) {
      navigate('/profile');
      return;
    }
    getOrgInvites();
    getGameInvites();
  }, [profile])

  useEffect(() => {
    if (!orgInvites) return;
    // console.log(orgInvites);
    const firstInvite = Object.values(orgInvites)
      .filter(i => i.status === 'pending')
      .sort((a, b) => a.ts_created > b.ts_created ? 1 : -1)[0]
    setSelectedOrgInvite(firstInvite);
  }, [orgInvites])

  useEffect(() => {
    if (!gameInvites) return;
    // console.log(gameInvites);
    const firstInvite = Object.values(gameInvites)
      .filter(i => i.status === 'pending')
      .sort((a, b) => a.ts_created > b.ts_created ? 1 : -1)[0]
    setSelectedGameInvite(firstInvite);
  }, [gameInvites])

  function getOrgInvites() {
    getOrgInvitesFromDb({
      'email': profile.email,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data, id) {
      orgInvitesRef.current = { ...orgInvitesRef.current, ...{ [id]: data } }
      setOrgInvites(orgInvitesRef.current);
    }
    function handleListener(unsub) {
      orgInvitesListener = unsub;
    }
  }

  function getGameInvites() {
    getGameInvitesFromDb({
      'inviteAppId': profile.appId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data, id) {
      gameInvitesRef.current = { ...gameInvitesRef.current, ...{ [id]: data } }
      setGameInvites(gameInvitesRef.current);
    }
    function handleListener(unsub) {
      gameInvitesListener = unsub;
    }
  }

  async function acceptDeclineInvite(invite, isAccepted) {
    setConfirmMessage(`Are you sure you want to <b>${isAccepted ? 'accept' : 'decline'}</b> ` +
      `this invite to manage the game <b>"${invite.gameName}"</b>? This action cannot be undone.`);
    approveRef.current = () => {
      continueApproveDecline();
    }

    async function continueApproveDecline() {
      setLoading(true);
      const now = new Date().getTime();
      const obj = {
        'isAccepted': isAccepted,
        'inviteId': invite.id,
        'ts': now,
        'appId': profile.appId,
        'gameId': invite.gameId,
        'type': 'game'
      }
      console.log(obj);
      
      const res = await UseCloudFunction(
        'acceptDeclineInvite',
        obj
      )
      console.log(res);
      
      setLoading(false);
      if (res.error) {
        setAlertMessage(`Something went wrong. Error: ${res.error}`);
        return;
      }
      removeApprovedInvite('game', invite.id);
      if (isAccepted) {
        navigate(`/manage/${invite.gamePath}`);
      } else {
        setAlertMessage('Invite declined successfully.');
      }
    }  
  }

  function removeApprovedInvite(type, id) {
    if (type === 'org') {
      let tempInvites = { ...orgInvitesRef.current };
      delete tempInvites[id];
      orgInvitesRef.current = { ...tempInvites };
      setOrgInvites(orgInvitesRef.current);
      setSelectedOrgInvite(null);
    } else if (type === 'game') {
      let tempInvites = { ...gameInvitesRef.current };
      delete tempInvites[id];
      gameInvitesRef.current = { ...tempInvites };
      setGameInvites(gameInvitesRef.current);
      setSelectedGameInvite(null);
    }
  }

  return (
    <div className={`home-page ${screenSize}`}>
      <Layout setShowFeedbackModal={setShowFeedbackModal}>
        <Routes>
          <Route path='' element={
            <HomeLanding />
          }></Route>
          <Route path='enrolled' element={
            <EnrolledContainer
              enrolledList={enrolledList} />
          }></Route>
          <Route path='managing/*' element={
            <ManagingContainer
              orgs={orgs}
              managingList={managingList}
              archivedList={archivedList}
              gameInvites={gameInvites}
              acceptDeclineInvite={acceptDeclineInvite} />
          }></Route>
          <Route path='archive' element={
            <ArchivedGamesContainer
              archivedList={archivedList}
              managingList={managingList} />
          }></Route>
          <Route path='archive/:templatePath' element={
            <ViewArchivedGame />
          }></Route>
          <Route path='creategame/*' element={
            <CreateEditGameContainer />
          }></Route>
          <Route path='joingame' element={
            <JoinGameWithEmail />
          }></Route>
          <Route path='joingame/:joinCode' element={
            <JoinGameWithEmail />
          }></Route>
          <Route path='myorgs/*' element={
            <MyOrgs
              orgs={orgs} />
          }></Route>
          <Route path='mycontent/*' element={
            <ContentManagerContainer />
          }></Route>
          <Route path='mycontent/:category' element={
            <ContentManagerContainer />
          }></Route>
          <Route path='resources' element={
            <ResourcesPage />
          }></Route>
          <Route path="*" element={
            <Navigate replace to="/404" />
          } />
        </Routes>
      </Layout>
      <FeedbackModal
        show={showFeedbackModal}
        cancel={() => setShowFeedbackModal(false)}
      />
      <OrgInviteHandlerModal
        invite={selectedOrgInvite}
        cancel={() => setSelectedOrgInvite(null)}
        removeApprovedInvite={removeApprovedInvite}
      />
      <GameInviteHandlerModal
        invite={selectedGameInvite}
        cancel={() => setSelectedGameInvite(null)}
        removeApprovedInvite={removeApprovedInvite}
        acceptDeclineInvite={acceptDeclineInvite}
      />
      <AnnouncementModal />
      <LegalApprovalModal />
      <ModalAlert
        show={!!alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader
        show={loading} />
    </div>
  )
}

export default HomePage